const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"m8 10l-5 8h10l-5-8Zm2.529.754L13.5 6L21 18h-5.943l-4.528-7.246Z\"/>"
};
export default data;
